
import { defineComponent } from "vue";
import { Logo } from "@/components/atoms";
import { NavBar, Pesquisa } from "@/components/molecules";

export default defineComponent({
  components: { Logo, NavBar, Pesquisa }
});
